const customerSampleAnalysesColumns = {
  orderId: {
    key: 'sample.orderId',
    label: 'orderNumber',
    type: 'text',
    sortable: 'custom',
    minWidth: 150,
  },
  sampleId: {
    key: 'analysis.sampleId',
    label: 'customerSampleId',
    type: 'text',
    sortable: 'custom',
    minWidth: 120,
  },
  laboratory: {
    key: 'analysis.laboratory',
    label: 'laboratories',
    type: 'enum',
    enum: 'laboratories',
    sortable: false,
    minWidth: 150,
  },
  analysisCode: {
    key: 'analysis.analysisCode',
    label: 'analysisCode',
    type: 'text',
    minWidth: 200,
  },
  locationName: {
    key: 'analysis.location.name',
    label: 'location',
    type: 'text',
    sortable: 'custom',
    minWidth: 150,
  },
  lastModifiedAt: {
    key: 'sample.lastModifiedAt',
    label: 'updatedAt',
    type: 'date',
    sortable: false,
    minWidth: 125,
  },
  orderSentAt: {
    key: 'orderSentAt',
    label: 'orderDate',
    type: 'date',
    sortable: false,
    minWidth: 130,
  },
  customerProductName: {
    key: 'sample.customerProductName',
    label: 'customerSampleCode',
    type: 'text',
    sortable: false,
    minWidth: 200,
  },
  productName: {
    key: 'sample.productName',
    label: 'productName',
    type: 'text',
    sortable: 'custom',
    minWidth: 150,
  },
  lot: {
    key: 'sample.lot',
    label: 'lot',
    type: 'text',
    sortable: 'custom',
    minWidth: 130,
  },
  sector: {
    key: 'sample.sector',
    label: 'sector',
    type: 'enum',
    enum: 'sectors',
    sortable: 'custom',
    minWidth: 230,
  },
  packagesNumber: {
    key: 'sample.packagesNumber',
    label: 'packagesNumber',
    type: 'text',
    sortable: false,
    minWidth: 130,
  },
  notes: {
    key: 'sample.notes',
    label: 'customerNotes',
    type: 'text',
    sortable: false,
    minWidth: 200,
  },
  finalCustomer: {
    key: 'sample.finalCustomer',
    label: 'finalCustomer',
    type: 'text',
    sortable: 'custom',
    minWidth: 200,
  },
  sampleDescription: {
    key: 'sample.sampleDescription',
    label: 'sampleDescription',
    type: 'enum',
    enum: 'sampleDescriptions',
    sortable: 'custom',
    minWidth: 200,
  },
};

export default customerSampleAnalysesColumns;
